import logo2001 from "../../assets/img/historicEvents/LogoVengeance/2001.png";
import logo2002 from "../../assets/img/historicEvents/LogoVengeance/2002.png";
import logo2003_2004 from "../../assets/img/historicEvents/LogoVengeance/2003-2004.png";
import logo2005 from "../../assets/img/historicEvents/LogoVengeance/2005.png";
import logo2006 from "../../assets/img/historicEvents/LogoVengeance/2006.png";
import logo2007 from "../../assets/img/historicEvents/LogoVengeance/2007.png";
import logo2011 from "../../assets/img/historicEvents/LogoVengeance/2011.png";

export const vengeanceDetail = {
  vengeance: {
    id: "vengeance",
    title: "Vengeance",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "vengeance",
        items: [
          {
            id: "vengeance-2001",
            title: "Vengeance",
            description: "2001",
            imgUrl: logo2001,
          },
          {
            id: "vengeance-2002",
            title: "Vengeance",
            description: "Quick & Merciless 2002",
            imgUrl: logo2002,
          },
          {
            id: "vengeance-2003",
            title: "Vengeance",
            description: "2003 - 2004",
            imgUrl: logo2003_2004,
          },
          {
            id: "vengeance-2005",
            title: "Vengeance",
            description: "Hell in a Cell 2005",
            imgUrl: logo2005,
          },
          {
            id: "vengeance-2006",
            title: "Vengeance",
            description: "2006",
            imgUrl: logo2006,
          },
          {
            id: "vengeance-2007",
            title: "Vengeance",
            description: "Night of Champions 2007",
            imgUrl: logo2007,
          },
          {
            id: "vengeance-2011",
            title: "Vengeance",
            description: "Vengeance Is Mine 2011",
            imgUrl: logo2011,
          },
        ],
      },
    ],
  },
};
